let language = localStorage.getItem("selectedLanguage");
let label;
if (language && language === "En") {
  label = {
    page: {
      home: "Home",
      dashboard: "Dashboard",
      aboutUs: "About Us",
      contactUs: "Contact Us",
      baseInformation: "Base Informations",
      users: "Users",
      products: "Products",
      addProduct: "New Product",
      editProduct: "Edit Product",
      orders: "Orders",
      addOrder: "New Order",
      editOrder: "Edit Order",
      support: "Support",
      tickets: "Tickets",
      addTicket: "Open Ticket",
      messages: "Messages",
      profile: "Profile",
      login: "Sign In",
      register: "Sign Up",
      notFound: "Oops! Are You Lost ?!",
      notAccess: "Sorry! You Don't Have Access To This Page",
      noAccess: "No Access",
      serverError: "Internal Server Error! Please Call The Technical Support",
      underConstruction:
        "This Page is Under Construction and will be Available Soon",
    },
    menu: {
      home: "Home",
      dashboard: "Dashboard",
      about: "About Us",
      contact: "Contact Us",
      users: "Users",
      messages: "Messages",
      tickets: "Tickets",
      support: "Support",
      products: "Products",
      orders: "Orders",
      addOrder: "New Order",
      cart: "Cart",
      shop: "Shop",
      baseInformation: "Base Informations",
      reports: "Reports",
      editProfile: "Update Profile",
      notifications: "Notifications",
      allNotifications: "Show all Notifications",
      allMessages: "Show all Messages",
      logout: "Logout",
      rejectedTemplate: "Blocked Account",
    },
    button: {
      login: "Sign In",
      register: "Sign Up",
      logout: "Logout",
      recoveryEmail: "Send Recovery Email",
      submit: "Submit",
      submitInfo: "Submit Informations",
      save: "Save",
      saveChanges: "Save Changes",
      add: "Add New",
      addUser: "New User",
      edit: "Update",
      delete: "Delete",
      confirmDelete: "Yes, Delete",
      editProfile: "Update Profile",
      editPassword: "Update Password",
      send: "Send",
      back: "Back",
      backToLogin: "Back to Login",
      backToHome: "Back to Home",
      home: "Home",
      cancel: "Cancel",
      addBase: "Add Base Info",
      reload: "Reload",
      addProduct: "Save Product",
      editProduct: "Update Profile",
    },
    table: {
      row: "#",
      actions: "Actions",
      title: "Title",
      qty: "Quantity",
      category: "Category",
      subject: "Subject",
      status: "Status",
      name: "Full Name",
      username: "Username",
      city: "City",
      role: "User Role",
      active: "Active",
      inactive: "Inactive",
    },
    form: {
      firstName: "First Name",
      lastName: "Last Name",
      fullName: "Full Name",
      userName: "نام کاربری",
      password: "رمز عبور",
      repeatPassword: "تکرار رمز عبور",
      currentPassword: "رمز عبور فعلی",
      newPassword: "رمز عبور جدید",
      email: "پست الکترونیک",
      mobile: "تلفن همراه",
      tel: "شماره تماس",
      phone: "تلفن ثابت",
      address: "آدرس",
      zipCode: "کد پستی",
      otpCode: "کد احراز هویت (کد تأیید)",
      image: "تصویر",
      file: "فایل",
      fileSize: "حداکثر حجم مجاز",
      fileType: "پسوندهای مجاز",
      fileRatio: "تصویر در ابعاد مربعی انتخاب کنید",
      department: "دپارتمان",
      birthDate: "تاریخ تولد",
      description: "توضیحات",
      content: "متن و محتوا",
      message: "متن پیام",
      subject: "موضوع",
      title: "عنوان",
      qty: "تعداد",
      digit: "عدد",
      category: "دسته بندی",
      city: "شهر / استان",
      role: "نقش کاربر",
      productName: "نام / عنوان محصول",
      annualDemand: "مقدار نیاز سالانه",
      sbu: "واحد کسب و کار (SBU)",
      resell: "فروش مجدد",
      weight: "وزن مخصوص",
      sendDate: "تاریخ ارسال",
      productDate: "تاریخ تولید",
      paymentMethod: "نحوه پرداخت",
      cashOption: "پرداخت نقدی",
      checkOption: "چک بانکی",
      attachment: "فایل پیوست",
      dropzoneTxt: "کلیک و یا فایل را در اینجا رها کنید",
    },
    caption: {
      yes: "بله",
      no: "خیر",
      ok: "تایید",
      dashboard: "داشبورد مدیریتی",
      profile: "ویرایش اطلاعات و رمز عبور حساب کاربری",
      password: "تغییر رمز عبور",
      avatar: "تصویر پروفایل کاربری",
      baseInformation: "اطلاعات و تنظیمات ابتدایی سامانه",
      addBaseInformation: "ثبت اطلاعات پایه جدید",
      editBaseInformation: "ویرایش اطلاعات پایه",
      users: "مدیریت کاربران سامانه",
      addUser: "ثبت کاربر جدید",
      editUser: "ویرایش اطلاعات کاربر",
      products: "مدیریت محصولات و تولیدات",
      orders: "مدیریت و بررسی سفارشات",
      messages: "پیام‌ها و چت کاربران",
      tickets: "پیام‌ها و درخواست‌های مشتریان",
      loading: "در حال بارگذاری ...",
      singIn: "ورود به سامانه",
      singUp: "عضویت در سامانه",
      haveAccount: "حساب کاربری دارید؟",
      haveNotAccount: "حساب کاربری ندارید؟",
      forgotPassword: "رمز عبور را فراموش کرده‌اید؟",
      emptyItem: "موردی جهت نمایش یافت نشد",
      emptyMessage: "لیست پیام‌های شما خالی می‌باشد",
      emptyTicket: "لیست تیکت‌های شما خالی می‌باشد",
      emptyNotify: "لیست اعلان‌ و هشدارها خالی می‌باشد",
      noMessage: "پیام جدیدی دریافت نکردید",
      noNotify: "اعلان جدیدی وجود ندارد",
      underConstruction:
        "این قسمت در حال توسعه می‌باشد و بزودی در دسترس قرار خواهد گرفت",
      rejectedTitle: "عدم دسترسی به سامانه",
      rejectedText: "حساب کاربری شما در این سامانه مسدود شده است",
      search: "جستجو",
      searchTable: "جستجو در جدول",
      searchAllColumns: "جستجو در همه ستون‌ها",
      delConfirm: "از حذف این مورد مطمئن هستید؟",
      resell: "آیا محصول برای فروش مجدد هست؟",
    },
  };
} else {
  label = {
    page: {
      home: "صفحه اصلی",
      dashboard: "داشبورد",
      aboutUs: "درباره ما",
      contactUs: "تماس با ما",
      baseInformation: "اطلاعات پایه",
      users: "کاربران و پرسنل",
      products: "محصولات و تولیدات",
      orders: "سفارشات مشتریان",
      addOrder: "ثبت سفارش",
      editOrder: "ویرایش سفارش",
      support: "پشتیبانی",
      tickets: "تیکت پشتیبانی",
      addTicket: "ثبت تیکت پشتیبانی",
      messages: "پیام‌ها",
      profile: "پروفایل کاربری",
      login: "ورود به سامانه",
      register: "عضویت",
      notFound: "راهتان را گم کرده‌اید ؟!",
      notAccess: "متأسفانه دسترسی شما برای مشاهده این قسمت محدود شده است",
      noAccess: "عدم دسترسی",
      serverError: "خطای ارتباط با سرور؛ لطفا به پشتیبانی فنی اطلاع دهید",
      underConstruction: "صفحه مدنظر در حال توسعه و برورسانی می‌باشد",
    },
    menu: {
      home: "صفحه اصلی",
      dashboard: "داشبورد",
      about: "درباره ما",
      contact: "راه های ارتباطی",
      users: "کاربران و پرسنل",
      messages: "پیام‌ها",
      tickets: "تیکت‌ها",
      support: "پشتیبانی",
      products: "محصولات",
      orders: "سفارشات",
      addOrder: "ثبت سفارش",
      cart: "سبد خرید",
      shop: "فروشگاه",
      baseInformation: "اطلاعات پایه",
      reports: "گزارشات",
      editProfile: "ویرایش پروفایل",
      notifications: "اعلان و هشدار‌ها",
      allNotifications: "مشاهده همه اعلان‌ها",
      allMessages: "مشاهده همه پیام‌ها",
      logout: "خروج",
      rejectedTemplate: "کاربر مسدود شده",
    },
    button: {
      login: "ورود به سامانه",
      register: "ثبت نام در سامانه",
      logout: "خروج از سامانه",
      recoveryEmail: "ارسال ایمیل بازیابی",
      submit: "ثبت",
      submitInfo: "ثبت اطلاعات",
      save: "ذخیره",
      saveChanges: "ثبت تغییرات",
      add: "ثبت جدید",
      addUser: "معرفی کاربر جدید",
      addCustomer: "اضافه کردن مشتری جدید",
      addAgent: "اضافه کردن نماینده جدید",
      addNewOrganization: "اضافه کردن سازمان جدید",
      addRole: "معرفی نقش جدید",
      addDocumentTypes: "معرفی انواع اسناد",
      addServiceGroup: "معرفی گروه خدمات",
      addServiceList: "لیست گروه خدمات",
      edit: "ویرایش",
      delete: "حذف",
      reset: "بازیابی رمزعبور",
      confirmDelete: "بله، حذف شود",
      confirmSubmit: "بله، ثبت شود",
      confirmDocuments: "تایید اسناد",
      editProfile: "ویرایش پروفایل",
      editPassword: "ویرایش رمز عبور",
      resetPassword: "بله، بازیابی شود",
      send: "ارسال",
      back: "بازگشت",
      backToLogin: "بازگشت به صفحه ورود",
      backToHome: "بازگشت به صفحه اصلی",
      home: "صفحه اصلی",
      cancel: "انصراف",
      cancelAndBack: "انصراف و بازگشت",
      addBase: "ثبت اطلاعات پایه",
      reload: "بارگذاری مجدد",
      editInfo: "ویرایش اطلاعات",
      addCategory: "ثبت دسته بندی",
      closeModal: "بستن پنجره",
      addDegree: "معرفی مدرک تحصیلی",
      addPosition: "معرفی پست سازمانی",
      addOrganization: "معرفی سازمان‌ها",
      createCategory: "ایجاد دسته‌بندی",
      createNewCategory: " معرفی دسته‌بندی",
      addSupportReports: "ثبت گزارش پشتیبانی",
      categoryList: "لیست دسته‌بندی‌ها",
      addDocument: "معرفی سند جدید",
      finalize: "نهایی کردن اسناد",
      addRequest: "ثبت درخواست",
    },
    table: {
      row: "ردیف",
      actions: "عملیات",
      title: "عنوان",
      qty: "تعداد",
      category: "دسته بندی",
      subject: "موضوع",
      status: "وضعیت",
      name: "نام و نام خانوادگی",
      username: "نام کاربری",
      city: "شهر / استان",
      role: "نقش کاربر",
      active: "فعال",
      inactive: "غیرفعال",
      fromDate: "از تاریخ",
      toDate: "تا تاریخ",
    },
    form: {
      firstName: "نام",
      lastName: "نام خانوادگی",
      fullName: "نام و نام خانوادگی",
      userName: "نام کاربری",
      gender: "جنسیت",
      password: "رمز عبور",
      repeatPassword: "تکرار رمز عبور",
      currentPassword: "رمز عبور فعلی",
      newPassword: "رمز عبور جدید",
      agentName: " نام مدیر",
      real: "حقیقی",
      legal: "حقوقی",
      nationalCode: "کدملی",
      nationalId: "شناسه ملی",
      workshopNumber: "شماره کارگاه",
      managerNationalCode: "کدملی مدیر",
      email: "پست الکترونیک",
      mobile: "تلفن همراه",
      tel: "شماره تماس",
      phone: "تلفن ثابت",
      fax: "فکس",
      address: "آدرس",
      brand: "نام تجاری",
      registrationNumber: "شماره ثبت",
      economicCode: "کد اقتصادی",
      responsibleUser: "کاربر مسئول",
      position: "پست سازمانی",
      organizations: "سازمان‌‌ها",
      UserCode: "کد کاربری",
      site: "سایت",
      zipCode: "کد پستی",
      otpCode: "کد احراز هویت (کد تأیید)",
      image: "تصویر",
      file: "فایل",
      fileSize: "حداکثر حجم مجاز",
      fileType: "پسوندهای مجاز",
      fileRatio: "تصویر در ابعاد مربعی انتخاب کنید",
      department: "دپارتمان",
      birthDate: "تاریخ تولد",
      description: "توضیحات",
      content: "متن و محتوا",
      message: "متن پیام",
      subject: "موضوع",
      title: "عنوان",
      qty: "تعداد",
      digit: "عدد",
      category: "دسته بندی",
      city: "شهر / استان",
      role: "نقش کاربر",
      productName: "نام / عنوان محصول",
      annualDemand: "مقدار نیاز سالانه",
      sbu: "واحد کسب و کار (SBU)",
      resell: "فروش مجدد",
      weight: "وزن مخصوص",
      sendDate: "تاریخ ارسال",
      productDate: "تاریخ تولید",
      paymentMethod: "نحوه پرداخت",
      cashOption: "پرداخت نقدی",
      checkOption: "چک بانکی",
      attachment: "فایل پیوست",
      dropzoneTxt: "کلیک و یا فایل را در اینجا رها کنید",
      advertisementDetails: "جزئیات آگهی",
      customerName: "نام مشتری",
      female: "زن",
      man: "مرد",
      degree: "مدرک تحصیلی",
      specialty: "تخصص",
      workExperienceSale: "سابقه کاری (سال)",
      workExperience: "سابقه کاری",
      salaryT: "حقوق (تومان)",
      salary: "حقوق",
      wantedSalaryT: "حقوق درخواستی (تومان)",
      wantedSalary: "حقوق درخواستی",
      workplace: "محل کار",
      militaryService: "وضعیت خدمت سربازی",
      jobTitle: "عنوان شغلی",
    },
    caption: {
      yes: "بله",
      no: "خیر",
      ok: "تایید",
      dashboard: "داشبورد مدیریتی",
      profile: "ویرایش اطلاعات و رمز عبور حساب کاربری",
      password: "تغییر رمز عبور",
      avatar: "تصویر پروفایل کاربری",
      baseInformation: "اطلاعات و تنظیمات ابتدایی سامانه",
      addBaseInformation: "ثبت اطلاعات پایه جدید",
      editBaseInformation: "ویرایش اطلاعات پایه",
      users: "مدیریت کاربران سامانه",
      addUser: "ثبت کاربر جدید",
      addRole: "ثبت نقش جدید",
      editUser: "ویرایش اطلاعات کاربر",
      editInfo: "ویرایش اطلاعات ",
      products: "مدیریت محصولات و تولیدات",
      orders: "مدیریت و بررسی سفارشات",
      messages: "پیام‌ها و چت کاربران",
      tickets: "پیام‌ها و درخواست‌های مشتریان",
      loading: "در حال بارگذاری ...",
      singIn: "ورود به سامانه",
      singUp: "عضویت در سامانه",
      haveAccount: "حساب کاربری دارید؟",
      haveNotAccount: "حساب کاربری ندارید؟",
      forgotPassword: "رمز عبور را فراموش کرده‌اید؟",
      emptyItem: "موردی جهت نمایش یافت نشد",
      emptyMessage: "لیست پیام‌های شما خالی می‌باشد",
      emptyTicket: "لیست تیکت‌های شما خالی می‌باشد",
      emptyNotify: "لیست اعلان‌ و هشدارها خالی می‌باشد",
      noMessage: "پیام جدیدی دریافت نکردید",
      noNotify: "اعلان جدیدی وجود ندارد",
      underConstruction:
        "این قسمت در حال توسعه می‌باشد و بزودی در دسترس قرار خواهد گرفت",
      rejectedTitle: "عدم دسترسی به سامانه",
      rejectedText: "حساب کاربری شما در این سامانه مسدود شده است",
      search: "جستجو",
      searchTable: "جستجو در جدول",
      searchAllColumns: "جستجو در همه ستون‌ها",
      delConfirm: "از حذف این مورد مطمئن هستید؟",
      resetConfirm: "از ریست کردن پسورد مطئن هستید؟",
      servicesGroup: "گروه خدمات",
      degree: "مدرک تحصیلی",
      addDegree: "معرفی مدرک تحصیلی",
      position: "پست سازمانی",
      addPosition: "معرفی پست سازمانی",
      organization: "سازمان‌های طرف قرارداد",
      organizationName: "نام سازمان",
      recruitment: "درخواست نیرو",
      request: "آگهی‌های کارجو",
      addCustomer: "معرفی مشتری",
      addAgents: "معرفی ‌نمایندگان",
      addOrganizations: "معرفی سازمان‌های طرف قرارداد",
      editCustomer: "ویرایش مشتری",
      editAgents: "ویرایش ‌نمایندگان",
      editOrganizations: "ویرایش سازمان‌های طرف قرارداد",
      addNewCategory: "معرفی دسته‌بندی ",
      ReferenceDocuments: "ارجاع اسناد",
      ConfirmationDocuments: "تایید اسناد",
      Registration: "ثبت اسناد",
    },
  };
}

export default label;
